module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-upload', {
    attrs: {
      "action": "/wapi/base/upload",
      "list-type": "picture-card",
      "file-list": _vm.fileList,
      "accept": "image/*",
      "before-upload": _vm.handleBeforeUpload,
      "on-success": _vm.handleSuccess,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.imageVisible),
      callback: function($$v) {
        _vm.imageVisible = $$v
      },
      expression: "imageVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.imageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a6e1a5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageUpload.vue
// module id = 854
// module chunks = 1